export default __webpack_public_path__ + "static/media/plus.21fd3d3a.svg";